import { Injector, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Brand } from '../models/product/dto/brand';
import { CreateBrandModalComponent } from '../views/shared/modals/create-brand-modal/create-brand-modal.component';
import { CreateBrandModalResult } from '../views/shared/modals/create-brand-modal/create-brand-modal-view-model';
import { ModalUtils } from '../utils/modal-utils';
import { exists } from '../functions/exists';

export class ModalCreateBrand {
  static open(
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector,
    onClose?: (brand: Brand) => void,
    prepopulatedBrand?: string,
    onContinueSetup?: (brand: Brand) => void
  ) {
    ngZone.run(() => {
      const modalRef = ngbModal.open(CreateBrandModalComponent, ModalUtils.createBrandsModalOptions(injector));
      modalRef.componentInstance.viewModel.connectNewBrandName(prepopulatedBrand);
      // Continue Setup only means something to callers that open brand editing afterwards.
      modalRef.componentInstance.viewModel.connectToCanContinueSetup(exists(onContinueSetup));
      modalRef.result
        .then((result: CreateBrandModalResult) => {
          if (!result?.brand) {
            return;
          }
          onClose?.(result.brand);
          if (result.continueSetup) {
            onContinueSetup?.(result.brand);
          }
        })
        .catch();
    });
  }
}
